import React, { useImperativeHandle, useState } from "react";
import { Button } from "./Elements";
import Modal from "./Modal";


const IntegrationResultModal = React.forwardRef(({ statusModalVisible, setStatusModalVisible }, ref) => {

    const [statusList, setStatusList] = useState({
        errorList: [],
        successList: []
    });

    useImperativeHandle(ref, () => ({

        showMessage(integrationResults) {
            var errorList = [], successList = [];
            if (integrationResults && integrationResults.length > 0) {
                for (let i = 0; i < integrationResults.length; i++) {
                    const element = integrationResults[i];
                    if (element.IsSuccess || element.isSuccess) {
                        successList.push(element);
                    } else {
                        errorList.push(element);
                    }
                }
            }
            setStatusList({
                errorList: errorList,
                successList: successList
            });
        }
    }));

    const getMessage = () => {

        if (statusList.successList.length == 0 && statusList.errorList.length > 0) {

            return "Aktarım yapılırken hata meydana geldi. Hata mesajı: " + statusList.errorList[0].errorDesc;
        }
        if (statusList.errorList.length == 0) {
            return "Aktarım başarılı bir şekilde gerçekleştirilmiştir.";

        }
        if (statusList.errorList.length > 0) {
            return `${statusList.successList.length} Ödeme Aktarımı Başarılı. ${statusList.errorList.length} Aktarım Başarısız oldu `;
        }
    }
    const getStatusImageUrl = () => {

        if (statusList.errorList.length == 0) {
            return "/icons/basarili.svg";
        }
        if (statusList.successList.length == 0) {

            return "/icons/basarisiz.svg";
        }
        if (statusList.errorList.length > 0) {
            return "/icons/basarisiz.svg";
        }
    }


    return (
        <Modal openModal={statusModalVisible} setOpenModal={setStatusModalVisible}>
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            Bilgilendirme Mesajı
                        </h3>
                        <div className="flex justify-center">
                            <div className="mt-4 flex flex-row items-center">
                                <img
                                    className="text-success h-10 w-10"
                                    src={getStatusImageUrl()}
                                    alt="success"
                                />
                                <p className="pl-2 text-sm text-gray-500" style={{
                                    wordBreak: "break-word",
                                    overflow: "auto",
                                    maxHeight: 250
                                }}>
                                    {getMessage()}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => setStatusModalVisible(false)}
                    >
                        Kapat
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default IntegrationResultModal;